import { useMutation } from '@tanstack/react-query';
import { accessControlAction } from '@/lib/api';

interface ShareKeyInput {
  key_id: string;
  recipient_name: string;
  recipient_phone?: string;
  recipient_email?: string;
  duration_seconds?: number;
}

interface ShareKeyResponse {
  qr_string: string;
  expires_at: string;
  recipient_name: string;
  shared_key_id: string;
}

export function useShareKey() {
  return useMutation({
    mutationFn: async (input: ShareKeyInput): Promise<ShareKeyResponse> => {
      const result = await accessControlAction<ShareKeyResponse>('share-key', { ...input });
      if (result.error) throw new Error(result.error);
      if (!result.data) throw new Error('Kunde inte dela nyckeln');
      return result.data;
    },
  });
}
